import { getClasses } from "../../utils";
import classes from "./DashboardCard.module.css";

type Props = {
  name: string;
  value: number | string;
  color: string;
  className?: string;
};

const DashboardCard: React.FC<Props> = ({
  name,
  value,
  color,
  className = "",
}) => {
  return (
    <div
      className={getClasses(classes.main, className)}
      style={{ backgroundColor: color }}>
      <div className={classes.value}>{value}</div>
      <div className={classes.name}>{name}</div>
    </div>
  );
};

export default DashboardCard;
